<template>
  <el-container>

    <el-row :gutter="10">
      <el-col :span="24">
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form :inline="true" size="mini">
                <el-form-item>
                  <el-button type="default" icon="el-icon-s-fold" @click="collapseHTree"></el-button>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="12">
              <el-form :inline="true" :model="formInline" size="mini" class="smui-form-right">
                <el-form-item label="套餐">
                  <el-input v-model="formInline.package_name" placeholder="套餐名称" clearable></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" icon="el-icon-search" @click="search()">查询</el-button>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
          
          <el-tabs v-model="tabActiveName" type="card" @tab-click="handleTabsClick">
            <el-tab-pane v-for="item in source_options" :label="item.label" :name="item.value"></el-tab-pane>
          </el-tabs>

          <!-- <div class="space-row"></div> -->

          <div class="sanmuui-body-container">
            
              <el-table
                id="tbGridView"
                ref="getTableInstance"
                :data="tableData"
                :height="tableViewHeight"
                v-loading="loadingTableData"
                @selection-change="handleSelectionChange"
                size="small"
                border
                style="width: 100%">
                <el-table-column
                  type="selection"
                  width="55">
                </el-table-column>
                <el-table-column
                  prop="package_name"
                  label="套餐"
                  width="200">
                </el-table-column>
                <el-table-column
                  prop="period_usage"
                  label="周期用量(MB)"
                  width="200">
                </el-table-column>
                <el-table-column
                  prop="period_months"
                  label="周期(月)"
                  width="100">
                </el-table-column>
                <el-table-column
                  prop="rechargeme"
                  label="可续套餐">
                  <template slot-scope="scope">
                    <el-tag class="items-tag" v-for="s in scope.row.recharge_pkgs.split(',')" v-show="scope.row.recharge_pkgs.length>0">{{ s }}</el-tag>
                    <el-button
                      size="mini"
                      @click="setRechargePkgsForm(scope.row.package_id, scope.row.package_name)">添加</el-button>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="is_usage_reset"
                  label="是否清零"
                  width="100">
                </el-table-column>
                <el-table-column
                  prop="is_addpkg"
                  label="叠加包"
                  width="100">
                </el-table-column>
                <el-table-column
                  prop="source_name"
                  label="卡源"
                  width="120">
                </el-table-column>
                <el-table-column
                  prop="operator_type"
                  label="运营商"
                  width="120">
                </el-table-column>
              </el-table>
          </div>

          <div class="dv-pagging-container">
            <el-pagination
              background
              layout="prev, pager, next"
              @current-change="handleCurrentChange"
              :page-size="pagging.pager_size"
              :pager-count="pagging.pager_count"
              :total="pagging.records_total"
              :current-page="pagging.current_page">
            </el-pagination>
          </div>
      </el-col>
    </el-row>

    <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" width="700px">
        <el-form :model="formNew" ref="formNew" label-width="80px" class="demo-form-inline" size="medium">
          <el-form-item label="当前套餐" :label-width="formLabelWidth" prop="pkg_name">
            <el-input v-model="formNew.pkg_name" autocomplete="off" :disabled="true" class="-form2-input-text"></el-input>
          </el-form-item>
        </el-form>
        <el-table
          ref="rechargeListTable"
          :data="rechargeTableData"
          @selection-change="handleSelectionChange2"
          height="300"
          size="small"
          border
          style="width: 100%">
            <el-table-column
              type="selection"
              width="55">
            </el-table-column>
            <el-table-column
              prop="package_name"
              label="套餐"
              width="150">
            </el-table-column>
            <el-table-column
              prop="period_usage"
              label="周期用量"
              width="100">
            </el-table-column>
            <el-table-column
              prop="period_months"
              label="周期"
              width="100">
            </el-table-column>
            <el-table-column
              prop="is_addpkg"
              label="叠加包"
              width="100">
            </el-table-column>
            <el-table-column
              prop="is_usage_reset"
              label="是否清零"
              width="100">
            </el-table-column>
        </el-table>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false" size="small">取 消</el-button>
          <el-button type="primary" @click="saveRechargePkg()" size="small">确 定</el-button>
        </div>
    </el-dialog>

  </el-container>
</template>

<script>
import Api from '../../api/index'

export default {
  name: 'pkgrechargelist_manage',
  data() {
    return {
      tabActiveName: "1",
      isVisible: false, // 控制浮动层是否显示
      dialogFormVisible: false,
      dialogTitle: "配置套餐续费权限",
      formInline: {
        source_id: null,
        operator_type: null,
        package_name: "",
        page_index: 1,
        page_size: 20,
        sort_field: '',
        sort_type: ''
      },
      source_options: [],
      card_type_options: [
        { value: '1', label: '移动卡' },
        { value: '2', label: '联通卡' },
        { value: '3', label: '海外卡' }
      ],
      displayPassword: false,
      formLabelWidth: "110px",
      formNew: {
        pkg_id: 0,
        pkg_name: "",
      },
      tableViewHeight: 600,
      multipleSelection: [],
      loadingTableData: false,
      holdTreeData: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      tableData: [],
      pagging: {
        records_total: 0,
        pager_count: 5,
        pager_size: 20,
        current_page: 1
      },
      multipleSelection2: [],
      rechargeTableData: []
    }
  },
  methods: {
    openLayer() {
      this.isVisible = true;
    },
    closeLayer() {
      this.isVisible = false;
    },
    handleCurrentChange(val) {
      this.pagging.current_page = val;
      this.search();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSelectionChange2(val) {
      this.multipleSelection2 = val;
    },
    handleTabsClick: function(tab, event) {
      this.pagging.current_page = 1;
      this.search();
    },
    loadSourceOptions: function() {
        this.source_options = [];
        Api.SourceOptions({}).then(res => {
            if(res && res.data) {
                res.data.forEach(element => {
                    this.source_options.push({
                        value: element.source_id,
                        label: element.source_name
                    })
                });
                // this.formPkgPrice.source_id = res.data[0].source_id;
            }
        });
    },
    refreshPageList: function() {
      this.search();
    },
    search: function() {
      this.loadingTableData = true;
      this.tableData = [];

      this.formInline.source_id = parseInt(this.tabActiveName);
      this.formInline.page_index = this.pagging.current_page;
      this.formInline.page_size = this.pagging.pager_size;
      Api.PkgRechargeListManage(this.formInline).then(res => {
        this.loadingTableData = false;
        if(res && res.code === 200 && res.data) {
          this.pagging.records_total = res.total;
          // let startNum = (this.pagging.current_page - 1) * this.pagging.pager_size;
          this.tableData = res.data;
        } else {
          // this.$message.error(err);
        }
      }).catch(err => {
        this.$message.error('错了哦，接口出错！' + err);
        this.loadingTableData = false;
      });
    },
    handleSelectCardType: function(cmd) {
      this.formNew.card_type_text = cmd.label;
      this.formNew.card_type = parseInt(cmd.value);
    },
    resetFormSourceInfo: function() {
      this.formNew = {
        source_id: 0,
        source_name: "",
        api_account: "",
        api_password: "",
        card_type: 0,
        card_type_text: "请选择",
        remark: "",
      };
    },
    setRechargePkgsForm: function(id, name) {
      this.formNew.pkg_id = id;
      this.formNew.pkg_name = name;
      this.dialogFormVisible = true;
      var argdata = {
        pkg_id: id
      };
      Api.GetSelPkgItems(argdata).then(res => {
        if(res && res.code === 200) {
          this.rechargeTableData = res.data.items;
          var self = this;
          setTimeout(function() {
            self.displayRechargeRowSel(res.data.exists);
          }, 800);
        }
      });
    },
    displayRechargeRowSel: function(selIds) {
      if(selIds.length > 0) {
        this.rechargeTableData.forEach(row => {
          if(selIds.indexOf(row.package_id) > -1) {
            this.$refs.rechargeListTable.toggleRowSelection(row);
          }
        })
      }
    },
    saveRechargePkg: function() {
      var masters = [];
      this.multipleSelection2.forEach(s => {
        masters.push(s.package_id);
      });
      var argdata = {
        pkg_id: this.formNew.pkg_id,
        recharge_pkgs: masters,
        status: 1
      }
      Api.AddPkgRechargeList(argdata).then(res => {
        if(res && res.code === 200) {
          this.$message({
            message: '恭喜你，提交成功！',
            type: 'success'
          });
          this.dialogFormVisible = false;
          this.search();
        } else {
          this.$message.error(`提交失败！${res ? res.msg : ''}`);
        }
      });
    }
  },
  mounted() {
    var h = document.body.clientHeight - 60 - 130;
    var h2 = document.body.clientHeight - 115;
    this.$nextTick(() => {
      const table = this.$refs.getTableInstance;
      if (table) {
        // 使用原生JavaScript设置高度
        table.$el.style.height = h + 'px';
        // 或者使用Vue.set来响应式地更新样式
        // this.$set(table.$el.style, 'height', '300px');
      }
      const tree = this.$refs.getTreeInstance;
      if(tree) {
        tree.$el.style.height = h2 + 'px';
      }
    });

    this.loadSourceOptions();
    this.search();
  }
}
</script>
<style>
.tree-divBox {
  padding-top: 10px;
  padding-left: 10px;
  width: 95%;
  min-height: 500px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
}
.smui-form-right {
  float: right;
}
.items-tag {
  margin-right: 5px;
}
</style>